"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.selectAccentStyles = selectAccentStyles;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function selectAccentStyles(tokens) {
  return {
    left: tokens.accentOffset,
    top: tokens.accentPadding,
    bottom: tokens.accentPadding,
    backgroundColor: tokens.accentBackgroundColor,
    width: tokens.accentWidth,
    position: 'absolute'
  };
}

/**
 * Content inside an item or control in a SideNav, themed by the SideNavItem theme
 */
const ItemContent = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    tokens
  } = _ref;
  const typographyTokens = (0, _utils.selectTokens)('Typography', tokens);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      tokens: typographyTokens,
      ref: ref,
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: [staticStyles.absolute, selectAccentStyles(tokens)]
    })]
  });
});
ItemContent.displayName = 'ItemContent';
ItemContent.propTypes = {
  tokens: (0, _utils.getTokensPropType)('SideNavItem'),
  children: _propTypes.default.node
};
const staticStyles = _StyleSheet.default.create({
  absolute: {
    position: 'absolute'
  }
});
var _default = exports.default = ItemContent;